
import { mapMutations, mapActions } from 'vuex'

import * as animationData from '~/assets/lottie/loader.json'
import AppContainer from '~/components/globals/AppContainer.vue';

export default {
  name: 'AppLayout',
  components: {
    AppContainer,
  },
  computed: {
    lottieData() {
      return animationData.default
    }
  },

  methods: {
    ...mapActions(['dumpAppData']),
    ...mapMutations({
      setPlacement: 'checkout/setPlacement'
    }),
  },

  beforeMount() {
    this.setPlacement('app')
    this.dumpAppData()
    console.log('*** dumpAppData happens on app.vue')
  },
}
